/*
 * @Author: 李才人
 * @Date: 2021-07-29 16:42:12
 * @LastEditors: 李才人
 * @LastEditTime: 2021-08-09 17:50:18
 * @FilePath: \m_saas_business_admin\src\modules\operationTools\config\questionnaire.ts
 * @Description:
 */

export enum IQuestionComonentType {
  Question = 0,
  Decoration = 1,
}

export interface optionItem {
  value: string;
  content: string;
  rightOption?: boolean;
  otherInput?: boolean;
  jsonConfig?: any;
  childList?: Array<optionItem>;
  inputMax?: null | undefined | number;
  subTitle?: string;
}
export interface IQuestion {
  id?: string;
  required?: number;
  number?: number;
  type?: QuestionType;
  style?: IQuestionComonentType;
  url?: string;
  whetherJoinQuestionBank?: boolean;
  fromQuestionBank?: boolean;
  catalogIds?: [];
}
export interface ISingleChoiceData extends IQuestion {
  title: string;
  itemScore?: number;
  required: number;
  optionContentType: string; // 是否必填: number;
  optionsList: Array<optionItem>;
  scoreRule?: string;

  jsonConfig: {
    subTitle: string;
    showIndex: boolean;
    otherInputForm: string;
    otherInputNumberMin: string | number | undefined;
    otherInputNumberMax: string | number | undefined;
    otherInputNumberPrecision: string | number | undefined;
    otherInputMin: string | number | undefined;
    otherInputMax: string | number | undefined;
    otherInputUnitType: string | number | undefined;
    unitFirst: string | number | undefined; // 第一单位
    unitSecond: string | number | undefined; // 第二单位
    secondOtherInputForm: string | number | undefined; // 第二单位 填写格式
    secondOtherInputNumberMin: string | number | undefined; // 第二单位 数值类型 最小数值
    secondOtherInputNumberMax: string | number | undefined; // 第二单位 数值类型 最大数值
    secondOtherInputNumberPrecision: string | number | undefined; // 第二单位 数值类型 小数点
    secondOtherInputMin: string | number | undefined; // 第二单位 其他类型 最小字数
    secondOtherInputMax: string | number | undefined; // 第二单位 其他类型 最大字数
    openPoint?: boolean;
  };
}
export interface ISingleChoicePickerData extends IQuestion {
  title: string;
  itemScore?: number;
  required: number;
  scoreRule?: string;

  optionContentType: string; // 是否必填: number;
  optionsList: Array<optionItem>;
  jsonConfig: {
    subTitle: string;
    showIndex: boolean;
    openPoint?: boolean;
  };
}
export interface IMultipleChoiceData extends IQuestion {
  title: string;
  required: number;
  optionContentType: string; // 是否必填: number;
  itemScore?: number;
  optionsList: Array<optionItem>;
  scoreRule?: string;
  jsonConfig: {
    subTitle: string;
    showIndex: boolean;
    otherInputForm: string;
    otherInputNumberMin: string | number | undefined;
    otherInputNumberMax: string | number | undefined;
    otherInputNumberPrecision: string | number | undefined;
    otherInputMin: string | number | undefined;
    otherInputMax: string | number | undefined;
    selectRangeMin: string | number;
    selectRangeMax: string | number;
    otherInputUnitType: string | number | undefined;
    unitFirst: string | number | undefined; // 第一单位
    unitSecond: string | number | undefined; // 第二单位
    secondOtherInputForm: string | number | undefined; // 第二单位 填写格式
    secondOtherInputNumberMin: string | number | undefined; // 第二单位 数值类型 最小数值
    secondOtherInputNumberMax: string | number | undefined; // 第二单位 数值类型 最大数值
    secondOtherInputNumberPrecision: string | number | undefined; // 第二单位 数值类型 小数点
    secondOtherInputMin: string | number | undefined; // 第二单位 其他类型 最小字数
    secondOtherInputMax: string | number | undefined; // 第二单位 其他类型 最大字数
  };
}
export interface IMultipleChoicePickerData extends IQuestion {
  title: string;
  required: number;
  optionContentType: string; // 是否必填: number;
  itemScore?: number;
  scoreRule?: string;

  optionsList: Array<optionItem>;
  jsonConfig: {
    subTitle: string;
    showIndex: boolean;
  };
}

export interface IFillInData extends IQuestion {
  title: string;
  required: number;
  content: string;
  itemScore?: number;
  rightText?: string;
  scoreRule?: string;
  jsonConfig: {
    subTitle: string;
    showIndex: boolean;
    inputForm: string;
    inputNumberMin: string | number | undefined;
    inputNumberMax: string | number | undefined;
    inputNumberPrecision: string | number | undefined;
    inputMin: string | number | undefined;
    inputMax: string | number | undefined;
  };
}
export interface IFillInRangeData extends IQuestion {
  title: string;
  required: number;
  content: string;
  itemScore?: number;
  rightText?: string;
  scoreRule?: string;
  jsonConfig: {
    subTitle: string;
    showIndex: boolean;
    numberValidate: boolean;
    inputForm: "NUMBER";
    content1: string | number | undefined;
    content2: string | number | undefined;
    inputNumberMin1: string | number | undefined;
    inputNumberMax1: string | number | undefined;
    inputNumberPrecision1: string | number | undefined;
    inputNumberMin2: string | number | undefined;
    inputNumberMax2: string | number | undefined;
    inputNumberPrecision2: string | number | undefined;
  };
}

export interface IFillInMultiItem {
  inputForm: string | number;
  content: string | number;
  title: string | number;
  inputNumberMin: string | number | undefined;
  inputNumberMax: string | number | undefined;
  inputNumberPrecision: string | number | undefined;
  inputMin: string | number | undefined;
  inputMax: string | number | undefined;
}
export interface IFillInMultiData extends IQuestion {
  title: string;
  required: number;
  content: string;
  itemScore?: number;
  rightText?: string;
  scoreRule?: string;
  jsonConfig: {
    subTitle: string;
    showIndex: boolean;
    inputList: Array<IFillInMultiItem>;
  };
}

// 矩阵填空结果类型的比较条件
export type FillInTableResultOperator = "LESS_THAN" | "LESS_THAN_OR_EQUAL" | "EQUAL" | "GREATER_THAN_OR_EQUAL" | "GREATER_THAN";
export interface IFillInTableResultCondition {
  operator: FillInTableResultOperator | "";
  value: number | null;
}

// 矩阵填空总分命中后的输出规则
export interface IFillInTableResultRule {
  conditions: Array<IFillInTableResultCondition>;
  resultType: string;
}

export interface IFillInTableData extends IQuestion {
  title: string;
  itemScore?: number;
  required: number;
  optionsList: Array<optionItem>;
  scoreRule?: string;
  jsonConfig: {
    subTitle: string;
    showIndex: boolean;
    rowList: Array<optionItem>;
    columnList: Array<optionItem>;
    otherInputForm: string;
    otherInputNumberMin: string | number | undefined;
    otherInputNumberMax: string | number | undefined;
    otherInputNumberPrecision: string | number | undefined;
    otherInputMin: string | number | undefined;
    otherInputMax: string | number | undefined;
    inputForm?: string;
    inputNumberMin?: string | number | null;
    inputNumberMax?: string | number | null;
    inputNumberPrecision?: number;
    inputMin?: string | number | null;
    inputMax?: string | number | null;
    isCountTotalNumber: boolean;
    crossCellText: string;
    totalFormulaType: boolean;
    totalFormula: string;
    isResultTypeEnabled: boolean;
    resultTypeTitle: string;
    resultTypeRuleList: Array<IFillInTableResultRule>;
    defaultResultType: string;
  };
}
export interface ISelectedoptionsData extends IQuestion {
  title: string;
  required: number;
  optionsList: Array<optionItem>;
}
export interface IPhoneNumberData extends IQuestion {
  title: string;
  required: number;
  phoneNumber: string;
}

export interface IAddonData extends IQuestion {
  required: number;
  uploadLimitCount: number;
  title: string;
  jsonConfig: {
    subTitle: string;
    picTypes?: Array<string>;
    fileTypes?: Array<string>;
    videoTypes?: Array<string>;
    showIndex: boolean;
    isIndeterminateFile: boolean;
    isIndeterminatePic: boolean;
    isIndeterminateVideo: boolean;
  };
}
export interface ISortData extends IQuestion {
  required: number;
  title: string;
  optionContentType: string; // 是否必填: number;
  itemScore?: number;
  optionsList: Array<optionItem>;
  jsonConfig: {
    subTitle: string;
    showIndex: boolean;
    selectRangeMin: string | number;
    selectRangeMax: string | number;
  };
}
export interface IProportionData extends IQuestion {
  required: number;
  title: string;
  optionContentType: string; // 是否必填: number;
  itemScore?: number;
  optionsList: Array<optionItem>;
  jsonConfig: {
    showIndex: boolean;
    total: number;
  };
}
export interface IDateTimeData extends IQuestion {
  required: number;
  uploadLimitCount: number;
  title: string;
  jsonConfig: {
    subTitle: string;
    showIndex: Boolean;
    dateType: String;
    minDateType: String | undefined;
    maxDateType: String | undefined;
    minRequirementDate: String | undefined;
    maxRequirementDate: String | undefined;
  };
}
export interface IAddressInputData extends IQuestion {
  required: number;
  uploadLimitCount: number;
  title: string;
  jsonConfig: {
    subTitle: string;
    showIndex: Boolean;
    addressType: String;
  };
}
export interface IOnlineBooking extends IQuestion {
  required: number; // 题目是否必答
  title: string; // 标题
  jsonConfig: {
    appointmentTimeMultiple: boolean; // 单个预约可选择多个时间
    subTitle: string; // 题目提示
    showIndex: boolean; // 是否显示序号
    appointmentName: string; // 预约名称
    imgUrl: string; // 图片地址
    appointmentMethod: string; // 预约方式
    weeklyAppointmentDate: Array<string>; // 每周可约日期
    dailyStartAndEndTime: string | Array<any>; // 每日起止时间
    hourlyDuration: string | number | undefined; // 每时段持续时间
    intervalTime: string | number | undefined; // 每时段名额
    quota: string | number | undefined; // 名额
    appointmentDateRangeType: string; // 可预约日期范围类型
    appointmentDateRange: Array<string>; // 可预约日期范围
    notAppointmentDateRange: string | Array<Array<any>>; // 不可约日期
  };
}
export interface IDepartment extends IQuestion {
  required: number; // 题目是否必答
  title: string; // 标题
  jsonConfig: {
    subTitle: string; // 题目提示
    showIndex: boolean; // 是否显示序号
  };
}

export interface IImageData extends IQuestion {
  required?: number;
  url?: string;
}
export interface ITextTData extends IQuestion {
  required?: number;
  text?: string;
}
export interface ICutOffLineData extends IQuestion {
  title: string;
  jsonConfig: {
    text: "";
    lineStyleType: string | number;
  };
}
export interface ICalculatorItem {
  type: "QUESTIONNAIRE" | "OPERATOR" | "FACTORS";
  value: string | number;
}
export interface IScoreVerificationRule {
  operate: "GREATER_AND_EQUAL" | "GREATER" | "EQUAL" | "LESS_AND_EQUAL" | "LESS" | "";
  score: number | null;
  verificationResult: "PASS" | "FAIL" | "";
}
export interface ICalculatorData extends IQuestion {
  title: string;
  jsonConfig: {
    subTitle: string;
    showIndex: boolean;
    percentMode: boolean;
    calculatorList?: Array<ICalculatorItem>;
    scoreVerificationEnabled?: boolean;
    scoreVerificationList?: Array<IScoreVerificationRule>;
  };
}
export interface IPageGapData extends IQuestion {
  text?: string;
}

export interface IQuestionItem<T> {
  type: number;
  name: string;
  title: string;
  componentName: QuestionType | DecorationType;
  icon: string;
  data?: T;
  // url?: ""; // $ 图片地址
}

export interface quesitonArr {
  name: string;
  key: string;
  questionItem: Array<IQuestionItem<QuestionFormDataType>>;
}

export enum DecorationType {
  picture = 5,
  text = 8,
  empty = -1,
  cutOffLine = 15,
  pageGap = 16,
  calculator = 24,
}

export enum QuestionType {
  empty = -1,
  singleChoice = 1,
  multipleChoice = 2,
  fillIn = 3,
  cascade = 4,
  uploadAddon = 6,
  sort = 21,
  proportion = 22,
  phoneNumber = 7,
  fillInMulti = 11,
  fillInRange = 12,
  fillInTable = 23,
  dateTime = 13,
  addressInput = 14,
  singleChoicePicker = 9,
  multipleChoicePicker = 10,
  patientName = 25,
  age = 26,
  sex = 27,
  diagnosisTime = 28,
  diagnosis = 29,
  onlineBooking = 30,
  department = 31,
}

export type QuestionFormDataType = ISingleChoiceData | IMultipleChoiceData | IFillInData | ISelectedoptionsData | IPhoneNumberData | IAddonData | IImageData | ITextTData;
export const questionData: Array<quesitonArr> = [
  {
    name: "选择组件",
    key: "selectArray",
    questionItem: [
      {
        type: IQuestionComonentType.Question,
        name: "单选题",
        title: "请选择以下选项",
        componentName: QuestionType.singleChoice,
        icon: "",
        data: {
          required: 1,

          optionContentType: "TEXT", //
          optionsList: [
            { value: "1", content: "选项1", otherInput: false, jsonConfig: { openPoint: false, pointValue: undefined } },
            { value: "2", content: "选项2", otherInput: false, jsonConfig: { openPoint: false, pointValue: undefined } },
          ],
          jsonConfig: {
            subTitle: "",
            showIndex: true,
            otherInputForm: "NONE",
            otherInputNumberMin: undefined,
            otherInputNumberMax: undefined,
            otherInputNumberPrecision: 0,
            otherInputMin: undefined,
            otherInputMax: undefined,
            openPoint: false,
            otherInputUnitType: "NONE",
            unitFirst: "",
            unitSecond: "", // 第二单位
            secondOtherInputForm: "NONE", // 第二单位 填写格式
            secondOtherInputNumberMin: undefined, // 第二单位 数值类型 最小数值
            secondOtherInputNumberMax: undefined, // 第二单位 数值类型 最大数值
            secondOtherInputNumberPrecision: 0, // 第二单位 数值类型 小数点
            secondOtherInputMin: undefined, // 第二单位 其他类型 最小字数
            secondOtherInputMax: undefined, // 第二单位 其他类型 最大字数
          },
        } as ISingleChoiceData,
      },

      {
        type: IQuestionComonentType.Question,
        name: "多选题",
        title: "请选择以下选项",
        componentName: QuestionType.multipleChoice,
        icon: "",
        data: {
          required: 1,
          optionContentType: "TEXT", //

          optionsList: [
            { value: "1", content: "选项1", otherInput: false, jsonConfig: { exclusive: false } },
            { value: "2", content: "选项2", otherInput: false, jsonConfig: { exclusive: false } },
          ],
          jsonConfig: {
            subTitle: "",
            showIndex: true,
            otherInputForm: "NONE",
            otherInputNumberMin: undefined,
            otherInputNumberMax: undefined,
            otherInputNumberPrecision: 0,
            otherInputMin: undefined,
            otherInputMax: undefined,
            selectRangeMin: "",
            selectRangeMax: "",
            otherInputUnitType: "NONE",
            unitFirst: "",
            unitSecond: "", // 第二单位
            secondOtherInputForm: "NONE", // 第二单位 填写格式
            secondOtherInputNumberMin: undefined, // 第二单位 数值类型 最小数值
            secondOtherInputNumberMax: undefined, // 第二单位 数值类型 最大数值
            secondOtherInputNumberPrecision: 0, // 第二单位 数值类型 小数点
            secondOtherInputMin: undefined, // 第二单位 其他类型 最小字数
            secondOtherInputMax: undefined, // 第二单位 其他类型 最大字数
          },
        } as IMultipleChoiceData,
      },
      {
        type: IQuestionComonentType.Question,
        name: "下拉单选题",
        title: "请选择以下选项",
        componentName: QuestionType.singleChoicePicker,
        icon: "",
        data: {
          required: 1,

          optionContentType: "TEXT", //
          optionsList: [
            { value: "1", content: "选项1", otherInput: false, jsonConfig: { openPoint: false, pointValue: undefined } },
            { value: "2", content: "选项2", otherInput: false, jsonConfig: { openPoint: false, pointValue: undefined } },
          ],
          jsonConfig: {
            subTitle: "",
            showIndex: true,
            openPoint: false,
          },
        } as ISingleChoicePickerData,
      },
      {
        type: IQuestionComonentType.Question,
        name: "下拉多选题",
        title: "请选择以下选项",
        componentName: QuestionType.multipleChoicePicker,
        icon: "",
        data: {
          required: 1,
          optionContentType: "TEXT", //

          optionsList: [
            { value: "1", content: "选项1", otherInput: false, jsonConfig: { exclusive: false } },
            { value: "2", content: "选项2", otherInput: false, jsonConfig: { exclusive: false } },
          ],
          jsonConfig: {
            subTitle: "",
            showIndex: true,
          },
        } as IMultipleChoicePickerData,
      },
    ],
  },
  {
    name: "填空组件",
    key: "inputArray",
    questionItem: [
      {
        type: IQuestionComonentType.Question,
        name: "简答题",
        title: "请填写本项内容",
        componentName: QuestionType.fillIn,
        icon: "",
        data: {
          title: "",
          required: 1,
          content: "",
          jsonConfig: {
            subTitle: "",
            default: "",
            showIndex: true,
            inputForm: "NONE",
            inputNumberMin: undefined,
            inputNumberMax: undefined,
            inputNumberPrecision: 0,
            inputMin: undefined,
            inputMax: undefined,
          },
        } as IFillInData,
      },
      {
        type: IQuestionComonentType.Question,
        name: "区间填空",
        title: "请填写本项内容",
        componentName: QuestionType.fillInRange,
        icon: "",
        data: {
          title: "",
          required: 1,
          content: "",
          jsonConfig: {
            subTitle: "",
            showIndex: true,
            numberValidate: true,
            inputForm: "NUMBER",
            content1: "",
            content2: "",
            inputNumberMin1: undefined,
            inputNumberMax1: undefined,
            inputNumberPrecision1: 0,
            inputNumberMin2: undefined,
            inputNumberMax2: undefined,
            inputNumberPrecision2: 0,
          },
        } as IFillInRangeData,
      },
      {
        type: IQuestionComonentType.Question,
        name: "横向填空",
        title: "请填写本项内容",
        componentName: QuestionType.fillInMulti,
        icon: "",
        data: {
          title: "",
          required: 1,
          content: "",
          jsonConfig: {
            subTitle: "",

            showIndex: true,
            inputList: [
              {
                inputForm: "NONE",
                content: "",
                title: "",
                inputNumberMin: undefined,
                inputNumberMax: undefined,
                inputNumberPrecision: 0,
                inputMin: undefined,
                inputMax: undefined,
              },
              {
                inputForm: "NONE",
                content: "",
                title: "",
                inputNumberMin: undefined,
                inputNumberMax: undefined,
                inputNumberPrecision: 0,
                inputMin: undefined,
                inputMax: undefined,
              },
            ],
          },
        } as IFillInMultiData,
      },
      {
        type: IQuestionComonentType.Question,
        name: "矩阵填空",
        title: "请填写本项内容",
        componentName: QuestionType.fillInTable,
        icon: "",
        data: {
          title: "",
          itemScore: 0,
          required: 1,
          optionsList: [],
          content: "",
          jsonConfig: {
            subTitle: "",
            showIndex: true,
            rowList: [
              {
                value: "",
                content: "行标题1",
                rightOption: false,
                otherInput: false,
                inputMax: undefined,
                subTitle: "",
              },
            ],
            columnList: [
              {
                value: "",
                content: "列标题1",
                rightOption: false,
                otherInput: false,
                inputMax: undefined,
                subTitle: "",
              },
            ],
            otherInputForm: "NONE",
            otherInputNumberMin: undefined,
            otherInputNumberMax: undefined,
            otherInputNumberPrecision: 0,
            otherInputMin: undefined,
            otherInputMax: undefined,
            isCountTotalNumber: false,
            crossCellText: "",
            totalFormulaType: false,
            totalFormula: "",
            isResultTypeEnabled: false,
            resultTypeTitle: "",
            resultTypeRuleList: [],
            defaultResultType: "暂无对应类型",
          },
        } as IFillInTableData,
      },
    ],
  },
  {
    name: "高级组件",
    key: "advanceArray",
    questionItem: [
      {
        type: IQuestionComonentType.Question,
        name: "排序题",
        title: "请对以下选项排序",
        componentName: QuestionType.sort,
        icon: "",
        data: {
          required: 1,
          title: "",
          optionContentType: "TEXT",
          jsonConfig: {
            subTitle: "",
            showIndex: true,
            selectRangeMin: "",
            selectRangeMax: "",
          },
          optionsList: [
            { value: "1", content: "选项1", rightOption: true, otherInput: false },
            { value: "2", content: "选项2", rightOption: false, otherInput: false },
          ],
        } as ISortData,
      },
      {
        type: IQuestionComonentType.Question,
        name: "比重题",
        title: "请填写以下内容",
        componentName: QuestionType.proportion,
        icon: "",
        data: {
          required: 1,
          optionContentType: "TEXT", //
          title: "",
          jsonConfig: {
            showIndex: true,
            total: 100,
          },
          optionsList: [
            { value: "1", content: "选项1", rightOption: true, otherInput: false },
            { value: "2", content: "选项2", rightOption: false, otherInput: false },
          ],
        } as IProportionData,
      },
      {
        type: IQuestionComonentType.Question,
        name: "上传附件",
        title: "请上传附件",
        componentName: QuestionType.uploadAddon,
        icon: "",
        data: {
          required: 1,
          uploadLimitCount: 1,
          title: "",
          jsonConfig: {
            subTitle: "",

            picTypes: [],
            fileTypes: [],
            videoTypes: [],
            showIndex: true,
            isIndeterminateFile: false,
            isIndeterminatePic: false,
            isIndeterminateVideo: false,
          },
        } as IAddonData,
      },
      {
        type: IQuestionComonentType.Question,
        name: "日期时间",
        title: "请选择日期时间",
        componentName: QuestionType.dateTime,
        icon: "",
        data: {
          required: 1,
          uploadLimitCount: 1,
          title: "",
          jsonConfig: {
            subTitle: "",
            showIndex: true,
            dateType: "date",
            minDateType: "",
            maxDateType: "",
            minRequirementDate: "",
            maxRequirementDate: "",
          },
        } as IDateTimeData,
      },
      {
        type: IQuestionComonentType.Question,
        name: "地址",
        title: "请选择地址",
        componentName: QuestionType.addressInput,
        icon: "",
        data: {
          required: 1,
          uploadLimitCount: 1,
          title: "",
          jsonConfig: {
            subTitle: "",

            showIndex: true,
            addressType: "p_c_a",
          },
        } as IAddressInputData,
      },
      {
        type: IQuestionComonentType.Question,
        name: "预约",
        title: "预约",
        componentName: QuestionType.onlineBooking,
        icon: "",
        data: {
          required: 1,
          // uploadLimitCount: 1,
          title: "",
          jsonConfig: {
            appointmentTimeMultiple: false,
            subTitle: "",
            showIndex: true,
            appointmentName: "",
            imgUrl: "",
            appointmentMethod: "APPOINTMENT_METHOD_PERIOD",
            weeklyAppointmentDate: [],
            dailyStartAndEndTime: ["09:00", "18:00"],
            hourlyDuration: undefined,
            intervalTime: undefined,
            quota: undefined,
            appointmentDateRangeType: "UNLIMITED",
            appointmentDateRange: [],
            notAppointmentDateRange: [],
          },
        } as IOnlineBooking,
      },
      {
        type: IQuestionComonentType.Question,
        name: "科室",
        title: "科室",
        componentName: QuestionType.department,
        icon: "",
        data: {
          required: 1,
          // uploadLimitCount: 1,
          title: "",
          jsonConfig: {
            subTitle: "",
            showIndex: true,
          },
        } as IOnlineBooking,
      },
    ],
  },
  {
    name: "其他组件",
    key: "decoArray",
    questionItem: [
      {
        type: IQuestionComonentType.Decoration,
        name: "图片",
        title: "请上传图片",
        componentName: DecorationType.picture,
        icon: "",
        data: {
          url: "",
          number: 0,
        } as IImageData,
      },
      {
        type: IQuestionComonentType.Decoration,
        name: "描述说明",
        title: "请填写描述说明",
        componentName: DecorationType.text,
        icon: "",
        data: {
          text: "",
        } as ITextTData,
      },
      {
        type: IQuestionComonentType.Decoration,
        name: "分割线",
        title: "",
        componentName: DecorationType.cutOffLine,
        icon: "",
        data: {
          jsonConfig: {
            lineStyleType: "1",
            text: "",
          },
        } as ICutOffLineData,
      },
      {
        type: IQuestionComonentType.Decoration,
        name: "计算字段",
        title: "计算结果是",
        componentName: DecorationType.calculator,
        icon: "",
        data: {
          required: 0,
          title: "",
          jsonConfig: {
            subTitle: "",
            showIndex: false,
            percentMode: false,
            calculatorList: [],
            scoreVerificationEnabled: false,
            scoreVerificationList: [],
          },
        } as ICalculatorData,
      },
      {
        type: IQuestionComonentType.Decoration,
        name: "分页",
        title: "",
        componentName: DecorationType.pageGap,
        icon: "",
        data: {
          text: "",
        } as IPageGapData,
      },
    ],
  },
  {
    name: "唯一性组件",
    key: "uniqueArray",
    questionItem: [
      {
        type: IQuestionComonentType.Question,
        name: "名称题",
        title: "请填写患者姓名首字母缩写",
        componentName: QuestionType.patientName,
        icon: "",
        data: {
          title: "",
          required: 1,
          content: "",
          jsonConfig: {
            subTitle: "",
            default: "",
            showIndex: true,
            inputForm: "NONE",
            inputNumberMin: undefined,
            inputNumberMax: undefined,
            inputNumberPrecision: 0,
            inputMin: undefined,
            inputMax: undefined,
          },
        } as any,
      },
      {
        type: IQuestionComonentType.Question,
        name: "年龄题",
        title: "请填写患者年龄",
        componentName: QuestionType.age,
        icon: "",
        data: {
          title: "",
          required: 1,
          content: "",
          jsonConfig: {
            subTitle: "",
            default: "",
            showIndex: true,
            inputForm: "NUMBER",
            inputNumberMin: undefined,
            inputNumberMax: undefined,
            inputNumberPrecision: 0,
            inputMin: undefined,
            inputMax: undefined,
          },
        } as any,
      },
      {
        type: IQuestionComonentType.Question,
        name: "性别题",
        title: "请选择患者性别",
        componentName: QuestionType.sex,
        icon: "",
        data: {
          required: 1,
          optionContentType: "TEXT", //
          optionsList: [
            { value: "male", content: "男", otherInput: false, jsonConfig: { openPoint: false, pointValue: undefined } },
            { value: "female", content: "女", otherInput: false, jsonConfig: { openPoint: false, pointValue: undefined } },
          ],
          jsonConfig: {
            subTitle: "",
            showIndex: true,
            otherInputForm: "NONE",
            otherInputNumberMin: undefined,
            otherInputNumberMax: undefined,
            otherInputNumberPrecision: 0,
            otherInputMin: undefined,
            otherInputMax: undefined,
            openPoint: false,
          },
        } as any,
      },
      {
        type: IQuestionComonentType.Question,
        name: "确诊时间题",
        title: "请填写患者确诊时间",
        componentName: QuestionType.diagnosisTime,
        icon: "",
        data: {
          required: 1,
          uploadLimitCount: 1,
          title: "",
          jsonConfig: {
            subTitle: "",
            showIndex: true,
            dateType: "date",
            minDateType: "",
            maxDateType: "",
            minRequirementDate: "",
            maxRequirementDate: "",
          },
        } as any,
      },
      {
        type: IQuestionComonentType.Question,
        name: "诊断题",
        title: "请选择诊断",
        componentName: QuestionType.diagnosis,
        icon: "",
        data: {
          required: 1,
          optionContentType: "TEXT", //

          optionsList: [
            { value: "选项1", content: "选项1", otherInput: false, jsonConfig: { exclusive: false } },
            { value: "选项2", content: "选项2", otherInput: false, jsonConfig: { exclusive: false } },
          ],
          jsonConfig: {
            subTitle: "",
            showIndex: true,
            otherInputForm: "NONE",
            otherInputNumberMin: undefined,
            otherInputNumberMax: undefined,
            otherInputNumberPrecision: 0,
            otherInputMin: undefined,
            otherInputMax: undefined,
            selectRangeMin: "",
            selectRangeMax: "",
            fillInMin: undefined,
            fillInMax: undefined,
          },
        } as any,
      },
    ],
  },
];
export const questionDataForQAE: Array<quesitonArr> = [
  {
    name: "选择组件",
    key: "selectArray",
    questionItem: [
      {
        type: IQuestionComonentType.Question,
        name: "单选题",
        title: "请选择以下选项",
        componentName: QuestionType.singleChoice,
        icon: "",
        data: {
          required: 1,

          optionContentType: "TEXT", //
          optionsList: [
            { value: "1", content: "选项1", otherInput: false, jsonConfig: { openPoint: false, pointValue: undefined } },
            { value: "2", content: "选项2", otherInput: false, jsonConfig: { openPoint: false, pointValue: undefined } },
          ],
          jsonConfig: {
            subTitle: "",
            showIndex: true,
            otherInputForm: "NONE",
            otherInputNumberMin: undefined,
            otherInputNumberMax: undefined,
            otherInputNumberPrecision: 0,
            otherInputMin: undefined,
            otherInputMax: undefined,
            openPoint: false,
            otherInputUnitType: "NONE",
            unitFirst: "",
            unitSecond: "", // 第二单位
            secondOtherInputForm: "NONE", // 第二单位 填写格式
            secondOtherInputNumberMin: undefined, // 第二单位 数值类型 最小数值
            secondOtherInputNumberMax: undefined, // 第二单位 数值类型 最大数值
            secondOtherInputNumberPrecision: 0, // 第二单位 数值类型 小数点
            secondOtherInputMin: undefined, // 第二单位 其他类型 最小字数
            secondOtherInputMax: undefined, // 第二单位 其他类型 最大字数
          },
        } as ISingleChoiceData,
      },

      {
        type: IQuestionComonentType.Question,
        name: "多选题",
        title: "请选择以下选项",
        componentName: QuestionType.multipleChoice,
        icon: "",
        data: {
          required: 1,
          optionContentType: "TEXT", //

          optionsList: [
            { value: "1", content: "选项1", otherInput: false, jsonConfig: { exclusive: false } },
            { value: "2", content: "选项2", otherInput: false, jsonConfig: { exclusive: false } },
          ],
          jsonConfig: {
            subTitle: "",
            showIndex: true,
            otherInputForm: "NONE",
            otherInputNumberMin: undefined,
            otherInputNumberMax: undefined,
            otherInputNumberPrecision: 0,
            otherInputMin: undefined,
            otherInputMax: undefined,
            selectRangeMin: "",
            selectRangeMax: "",
            otherInputUnitType: "NONE",
            unitFirst: "",
            unitSecond: "", // 第二单位
            secondOtherInputForm: "NONE", // 第二单位 填写格式
            secondOtherInputNumberMin: undefined, // 第二单位 数值类型 最小数值
            secondOtherInputNumberMax: undefined, // 第二单位 数值类型 最大数值
            secondOtherInputNumberPrecision: 0, // 第二单位 数值类型 小数点
            secondOtherInputMin: undefined, // 第二单位 其他类型 最小字数
            secondOtherInputMax: undefined, // 第二单位 其他类型 最大字数
          },
        } as IMultipleChoiceData,
      },
      {
        type: IQuestionComonentType.Question,
        name: "下拉单选题",
        title: "请选择以下选项",
        componentName: QuestionType.singleChoicePicker,
        icon: "",
        data: {
          required: 1,

          optionContentType: "TEXT", //
          optionsList: [
            { value: "1", content: "选项1", otherInput: false, jsonConfig: { openPoint: false, pointValue: undefined } },
            { value: "2", content: "选项2", otherInput: false, jsonConfig: { openPoint: false, pointValue: undefined } },
          ],
          jsonConfig: {
            subTitle: "",
            showIndex: true,
            openPoint: false,
          },
        } as ISingleChoicePickerData,
      },
      {
        type: IQuestionComonentType.Question,
        name: "下拉多选题",
        title: "请选择以下选项",
        componentName: QuestionType.multipleChoicePicker,
        icon: "",
        data: {
          required: 1,
          optionContentType: "TEXT", //

          optionsList: [
            { value: "1", content: "选项1", otherInput: false, jsonConfig: { exclusive: false } },
            { value: "2", content: "选项2", otherInput: false, jsonConfig: { exclusive: false } },
          ],
          jsonConfig: {
            subTitle: "",
            showIndex: true,
          },
        } as IMultipleChoicePickerData,
      },
    ],
  },
  {
    name: "填空组件",
    key: "inputArray",
    questionItem: [
      {
        type: IQuestionComonentType.Question,
        name: "简答题",
        title: "请填写本项内容",
        componentName: QuestionType.fillIn,
        icon: "",
        data: {
          title: "",
          required: 1,
          content: "",
          jsonConfig: {
            subTitle: "",
            default: "",
            showIndex: true,
            inputForm: "NONE",
            inputNumberMin: undefined,
            inputNumberMax: undefined,
            inputNumberPrecision: 0,
            inputMin: undefined,
            inputMax: undefined,
          },
        } as IFillInData,
      },
      {
        type: IQuestionComonentType.Question,
        name: "区间填空",
        title: "请填写本项内容",
        componentName: QuestionType.fillInRange,
        icon: "",
        data: {
          title: "",
          required: 1,
          content: "",
          jsonConfig: {
            subTitle: "",
            showIndex: true,
            numberValidate: true,
            inputForm: "NUMBER",
            content1: "",
            content2: "",
            inputNumberMin1: undefined,
            inputNumberMax1: undefined,
            inputNumberPrecision1: 0,
            inputNumberMin2: undefined,
            inputNumberMax2: undefined,
            inputNumberPrecision2: 0,
          },
        } as IFillInRangeData,
      },
      {
        type: IQuestionComonentType.Question,
        name: "横向填空",
        title: "请填写本项内容",
        componentName: QuestionType.fillInMulti,
        icon: "",
        data: {
          title: "",
          required: 1,
          content: "",
          jsonConfig: {
            subTitle: "",

            showIndex: true,
            inputList: [
              {
                inputForm: "NONE",
                content: "",
                title: "",
                inputNumberMin: undefined,
                inputNumberMax: undefined,
                inputNumberPrecision: 0,
                inputMin: undefined,
                inputMax: undefined,
              },
              {
                inputForm: "NONE",
                content: "",
                title: "",
                inputNumberMin: undefined,
                inputNumberMax: undefined,
                inputNumberPrecision: 0,
                inputMin: undefined,
                inputMax: undefined,
              },
            ],
          },
        } as IFillInMultiData,
      },
      // {
      //   type: IQuestionComonentType.Question,
      //   name: "矩阵填空",
      //   title: "请填写本项内容",
      //   componentName: QuestionType.fillInTable,
      //   icon: "",
      //   data: {
      //     title: "",
      //     itemScore: 0,
      //     required: 1,
      //     optionsList: [],
      //     content: "",
      //     jsonConfig: {
      //       subTitle: "",
      //       showIndex: true,
      //       rowList: [
      //         {
      //           value: "",
      //           content: "行标题1",
      //           rightOption: false,
      //           otherInput: false,
      //           inputMax: undefined,
      //           subTitle: "",
      //         },
      //       ],
      //       columnList: [
      //         {
      //           value: "",
      //           content: "列标题1",
      //           rightOption: false,
      //           otherInput: false,
      //           inputMax: undefined,
      //           subTitle: "",
      //         },
      //       ],
      //       otherInputForm: "NONE",
      //       otherInputNumberMin: undefined,
      //       otherInputNumberMax: undefined,
      //       otherInputNumberPrecision: 0,
      //       otherInputMin: undefined,
      //       otherInputMax: undefined,
      //       isCountTotalNumber: false,
      //     },
      //   } as IFillInTableData,
      // },
    ],
  },
  {
    name: "高级组件",
    key: "advanceArray",
    questionItem: [
      {
        type: IQuestionComonentType.Question,
        name: "排序题",
        title: "请对以下选项排序",
        componentName: QuestionType.sort,
        icon: "",
        data: {
          required: 1,
          title: "",
          optionContentType: "TEXT",
          jsonConfig: {
            subTitle: "",
            showIndex: true,
            selectRangeMin: "",
            selectRangeMax: "",
          },
          optionsList: [
            { value: "1", content: "选项1", rightOption: true, otherInput: false },
            { value: "2", content: "选项2", rightOption: false, otherInput: false },
          ],
        } as ISortData,
      },
      {
        type: IQuestionComonentType.Question,
        name: "比重题",
        title: "请填写以下内容",
        componentName: QuestionType.proportion,
        icon: "",
        data: {
          required: 1,
          optionContentType: "TEXT", //
          title: "",
          jsonConfig: {
            showIndex: true,
            total: 100,
          },
          optionsList: [
            { value: "1", content: "选项1", rightOption: true, otherInput: false },
            { value: "2", content: "选项2", rightOption: false, otherInput: false },
          ],
        } as IProportionData,
      },
      {
        type: IQuestionComonentType.Question,
        name: "上传附件",
        title: "请上传附件",
        componentName: QuestionType.uploadAddon,
        icon: "",
        data: {
          required: 1,
          uploadLimitCount: 1,
          title: "",
          jsonConfig: {
            subTitle: "",

            picTypes: [],
            fileTypes: [],
            videoTypes: [],
            showIndex: true,
            isIndeterminateFile: false,
            isIndeterminatePic: false,
            isIndeterminateVideo: false,
          },
        } as IAddonData,
      },
      {
        type: IQuestionComonentType.Question,
        name: "日期时间",
        title: "请选择日期时间",
        componentName: QuestionType.dateTime,
        icon: "",
        data: {
          required: 1,
          uploadLimitCount: 1,
          title: "",
          jsonConfig: {
            subTitle: "",
            showIndex: true,
            dateType: "date",
            minDateType: "",
            maxDateType: "",
            minRequirementDate: "",
            maxRequirementDate: "",
          },
        } as IDateTimeData,
      },
      {
        type: IQuestionComonentType.Question,
        name: "地址",
        title: "请选择地址",
        componentName: QuestionType.addressInput,
        icon: "",
        data: {
          required: 1,
          uploadLimitCount: 1,
          title: "",
          jsonConfig: {
            subTitle: "",

            showIndex: true,
            addressType: "p_c_a",
          },
        } as IAddressInputData,
      },
      // {
      //   type: IQuestionComonentType.Question,
      //   name: "预约",
      //   title: "预约",
      //   componentName: QuestionType.onlineBooking,
      //   icon: "",
      //   data: {
      //     required: 1,
      //     // uploadLimitCount: 1,
      //     title: "",
      //     jsonConfig: {
      //       appointmentTimeMultiple: false,
      //       subTitle: "",
      //       showIndex: true,
      //       appointmentName: "",
      //       imgUrl: "",
      //       appointmentMethod: "APPOINTMENT_METHOD_PERIOD",
      //       weeklyAppointmentDate: [],
      //       dailyStartAndEndTime: ["09:00", "18:00"],
      //       hourlyDuration: undefined,
      //       intervalTime: undefined,
      //       quota: undefined,
      //       appointmentDateRangeType: "UNLIMITED",
      //       appointmentDateRange: [],
      //       notAppointmentDateRange: [],
      //     },
      //   } as IOnlineBooking,
      // },
      {
        type: IQuestionComonentType.Question,
        name: "科室",
        title: "科室",
        componentName: QuestionType.department,
        icon: "",
        data: {
          required: 1,
          // uploadLimitCount: 1,
          title: "",
          jsonConfig: {
            subTitle: "",
            showIndex: true,
          },
        } as IOnlineBooking,
      },
    ],
  },
  {
    name: "其他组件",
    key: "decoArray",
    questionItem: [
      {
        type: IQuestionComonentType.Decoration,
        name: "图片",
        title: "请上传图片",
        componentName: DecorationType.picture,
        icon: "",
        data: {
          url: "",
          number: 0,
        } as IImageData,
      },
      {
        type: IQuestionComonentType.Decoration,
        name: "描述说明",
        title: "请填写描述说明",
        componentName: DecorationType.text,
        icon: "",
        data: {
          text: "",
        } as ITextTData,
      },
      {
        type: IQuestionComonentType.Decoration,
        name: "分割线",
        title: "",
        componentName: DecorationType.cutOffLine,
        icon: "",
        data: {
          jsonConfig: {
            lineStyleType: "1",
            text: "",
          },
        } as ICutOffLineData,
      },
      {
        type: IQuestionComonentType.Decoration,
        name: "计算字段",
        title: "计算结果是",
        componentName: DecorationType.calculator,
        icon: "",
        data: {
          required: 0,
          title: "",
          jsonConfig: {
            subTitle: "",
            showIndex: false,
            percentMode: false,
            calculatorList: [],
            scoreVerificationEnabled: false,
            scoreVerificationList: [],
          },
        } as ICalculatorData,
      },
      {
        type: IQuestionComonentType.Decoration,
        name: "分页",
        title: "",
        componentName: DecorationType.pageGap,
        icon: "",
        data: {
          text: "",
        } as IPageGapData,
      },
    ],
  },
  // {
  //   name: "唯一性组件",
  //   key: "uniqueArray",
  //   questionItem: [
  //     {
  //       type: IQuestionComonentType.Question,
  //       name: "名称题",
  //       title: "请填写患者姓名首字母缩写",
  //       componentName: QuestionType.patientName,
  //       icon: "",
  //       data: {
  //         title: "",
  //         required: 1,
  //         content: "",
  //         jsonConfig: {
  //           subTitle: "",
  //           default: "",
  //           showIndex: true,
  //           inputForm: "NONE",
  //           inputNumberMin: undefined,
  //           inputNumberMax: undefined,
  //           inputNumberPrecision: 0,
  //           inputMin: undefined,
  //           inputMax: undefined,
  //         },
  //       } as any,
  //     },
  //     {
  //       type: IQuestionComonentType.Question,
  //       name: "年龄题",
  //       title: "请填写患者年龄",
  //       componentName: QuestionType.age,
  //       icon: "",
  //       data: {
  //         title: "",
  //         required: 1,
  //         content: "",
  //         jsonConfig: {
  //           subTitle: "",
  //           default: "",
  //           showIndex: true,
  //           inputForm: "NUMBER",
  //           inputNumberMin: undefined,
  //           inputNumberMax: undefined,
  //           inputNumberPrecision: 0,
  //           inputMin: undefined,
  //           inputMax: undefined,
  //         },
  //       } as any,
  //     },
  //     {
  //       type: IQuestionComonentType.Question,
  //       name: "性别题",
  //       title: "请选择患者性别",
  //       componentName: QuestionType.sex,
  //       icon: "",
  //       data: {
  //         required: 1,
  //         optionContentType: "TEXT", //
  //         optionsList: [
  //           { value: "male", content: "男", otherInput: false, jsonConfig: { openPoint: false, pointValue: undefined } },
  //           { value: "female", content: "女", otherInput: false, jsonConfig: { openPoint: false, pointValue: undefined } },
  //         ],
  //         jsonConfig: {
  //           subTitle: "",
  //           showIndex: true,
  //           otherInputForm: "NONE",
  //           otherInputNumberMin: undefined,
  //           otherInputNumberMax: undefined,
  //           otherInputNumberPrecision: 0,
  //           otherInputMin: undefined,
  //           otherInputMax: undefined,
  //           openPoint: false,
  //         },
  //       } as any,
  //     },
  //     {
  //       type: IQuestionComonentType.Question,
  //       name: "确诊时间题",
  //       title: "请填写患者确诊时间",
  //       componentName: QuestionType.diagnosisTime,
  //       icon: "",
  //       data: {
  //         required: 1,
  //         uploadLimitCount: 1,
  //         title: "",
  //         jsonConfig: {
  //           subTitle: "",
  //           showIndex: true,
  //           dateType: "date",
  //           minDateType: "",
  //           maxDateType: "",
  //           minRequirementDate: "",
  //           maxRequirementDate: "",
  //         },
  //       } as any,
  //     },
  //     {
  //       type: IQuestionComonentType.Question,
  //       name: "诊断题",
  //       title: "请选择诊断",
  //       componentName: QuestionType.diagnosis,
  //       icon: "",
  //       data: {
  //         required: 1,
  //         optionContentType: "TEXT", //

  //         optionsList: [
  //           { value: "选项1", content: "选项1", otherInput: false, jsonConfig: { exclusive: false } },
  //           { value: "选项2", content: "选项2", otherInput: false, jsonConfig: { exclusive: false } },
  //         ],
  //         jsonConfig: {
  //           subTitle: "",
  //           showIndex: true,
  //           otherInputForm: "NONE",
  //           otherInputNumberMin: undefined,
  //           otherInputNumberMax: undefined,
  //           otherInputNumberPrecision: 0,
  //           otherInputMin: undefined,
  //           otherInputMax: undefined,
  //           selectRangeMin: "",
  //           selectRangeMax: "",
  //           fillInMin: undefined,
  //           fillInMax: undefined,
  //         },
  //       } as any,
  //     },
  //   ],
  // },
];
export const questionDataForReviews: Array<quesitonArr> = [
  {
    name: "填空组件",
    key: "inputArray",
    questionItem: [
      {
        type: IQuestionComonentType.Question,
        name: "简答题",
        title: "请填写本项内容",
        componentName: QuestionType.fillIn,
        icon: "",
        data: {
          title: "",
          required: 1,
          content: "",
          jsonConfig: {
            subTitle: "",
            default: "",
            showIndex: true,
            inputForm: "NONE",
            inputNumberMin: undefined,
            inputNumberMax: undefined,
            inputNumberPrecision: 0,
            inputMin: undefined,
            inputMax: undefined,
          },
        } as IFillInData,
      },

      {
        type: IQuestionComonentType.Question,
        name: "矩阵填空",
        title: "请填写本项内容",
        componentName: QuestionType.fillInTable,
        icon: "",
        data: {
          title: "",
          itemScore: 0,
          required: 1,
          optionsList: [],
          content: "",
          jsonConfig: {
            subTitle: "",
            showIndex: true,
            rowList: [
              {
                value: "",
                content: "行标题1",
                rightOption: false,
                otherInput: false,
                inputMax: undefined,
                subTitle: "",
              },
            ],
            columnList: [
              {
                value: "",
                content: "列标题1",
                rightOption: false,
                otherInput: false,
                inputMax: null,
                subTitle: "",
              },
            ],
            otherInputForm: "NONE",
            otherInputNumberMin: undefined,
            otherInputNumberMax: undefined,
            otherInputNumberPrecision: 0,
            otherInputMin: undefined,
            otherInputMax: undefined,
            isCountTotalNumber: false,
            crossCellText: "",
            totalFormulaType: false,
            totalFormula: "",
            isResultTypeEnabled: false,
            resultTypeTitle: "",
            resultTypeRuleList: [],
            defaultResultType: "暂无对应类型",
          },
        } as IFillInTableData,
      },
    ],
  },
];

export const testData: Array<quesitonArr> = [
  {
    name: "选择组件",
    key: "selectArray",
    questionItem: [
      {
        type: IQuestionComonentType.Question,
        name: "单选题",
        title: "请选择以下选项",
        componentName: QuestionType.singleChoice,
        icon: "",
        data: {
          required: 1,
          itemScore: 0,
          optionContentType: "TEXT", //
          scoreRule: "SAME",
          optionsList: [
            { value: "1", content: "选项1", otherInput: false, rightOption: true, jsonConfig: { openPoint: false, pointValue: undefined, itemScore: 0 } },
            { value: "2", content: "选项2", otherInput: false, rightOption: false, jsonConfig: { openPoint: false, pointValue: undefined, itemScore: 0 } },
          ],
          jsonConfig: {
            subTitle: "",
            showIndex: true,
            otherInputForm: "NONE",
            otherInputNumberMin: undefined,
            otherInputNumberMax: undefined,
            otherInputNumberPrecision: 0,
            otherInputMin: undefined,
            otherInputMax: undefined,
            openPoint: false,
            otherInputUnitType: "NONE",
            unitFirst: "",
            unitSecond: "", // 第二单位
            secondOtherInputForm: "NONE", // 第二单位 填写格式
            secondOtherInputNumberMin: undefined, // 第二单位 数值类型 最小数值
            secondOtherInputNumberMax: undefined, // 第二单位 数值类型 最大数值
            secondOtherInputNumberPrecision: 0, // 第二单位 数值类型 小数点
            secondOtherInputMin: undefined, // 第二单位 其他类型 最小字数
            secondOtherInputMax: undefined, // 第二单位 其他类型 最大字数
          },
        } as ISingleChoiceData,
      },

      {
        type: IQuestionComonentType.Question,
        name: "多选题",
        title: "请选择以下选项",
        componentName: QuestionType.multipleChoice,
        icon: "",
        data: {
          required: 1,
          optionContentType: "TEXT", //
          itemScore: 0,

          scoreRule: "SAME",
          optionsList: [
            { value: "1", content: "选项1", otherInput: false, rightOption: true, jsonConfig: { exclusive: false, itemScore: 0 } },
            { value: "2", content: "选项2", otherInput: false, rightOption: false, jsonConfig: { exclusive: false, itemScore: 0 } },
          ],
          jsonConfig: {
            subTitle: "",
            showIndex: true,
            otherInputForm: "NONE",
            otherInputNumberMin: undefined,
            otherInputNumberMax: undefined,
            otherInputNumberPrecision: 0,
            otherInputMin: undefined,
            otherInputMax: undefined,
            selectRangeMin: "",
            selectRangeMax: "",
            otherInputUnitType: "NONE",
            unitFirst: "",
            unitSecond: "", // 第二单位
            secondOtherInputForm: "NONE", // 第二单位 填写格式
            secondOtherInputNumberMin: undefined, // 第二单位 数值类型 最小数值
            secondOtherInputNumberMax: undefined, // 第二单位 数值类型 最大数值
            secondOtherInputNumberPrecision: 0, // 第二单位 数值类型 小数点
            secondOtherInputMin: undefined, // 第二单位 其他类型 最小字数
            secondOtherInputMax: undefined, // 第二单位 其他类型 最大字数
          },
        } as IMultipleChoiceData,
      },
    ],
  },
  {
    name: "其他组件",
    key: "decoArray",
    questionItem: [
      {
        type: IQuestionComonentType.Decoration,
        name: "图片",
        title: "请上传图片",
        componentName: DecorationType.picture,
        icon: "",
        data: {
          url: "",
          number: 0,
        } as IImageData,
      },
      {
        type: IQuestionComonentType.Decoration,
        name: "描述说明",
        title: "请填写描述说明",
        componentName: DecorationType.text,
        icon: "",
        data: {
          text: "",
        } as ITextTData,
      },
      {
        type: IQuestionComonentType.Decoration,
        name: "分割线",
        title: "",
        componentName: DecorationType.cutOffLine,
        icon: "",
        data: {
          jsonConfig: {
            lineStyleType: "1",
            text: "",
          },
        } as ICutOffLineData,
      },

      {
        type: IQuestionComonentType.Decoration,
        name: "分页",
        title: "",
        componentName: DecorationType.pageGap,
        icon: "",
        data: {
          text: "",
        } as IPageGapData,
      },
    ],
  },
];
export type QuestionDataType = typeof questionData | typeof testData;
export const decorationData: Array<IQuestionItem<QuestionFormDataType>> = [
  {
    type: IQuestionComonentType.Decoration,
    name: "图片",
    title: "请上传图片",
    componentName: DecorationType.picture,
    icon: "",
    data: {
      url: "",
      number: 0,
    } as IImageData,
  },
  {
    type: IQuestionComonentType.Decoration,
    name: "文字",
    title: "请填写文字",
    componentName: DecorationType.text,
    icon: "",
    data: {
      text: "",
    } as ITextTData,
  },
];

export type DecorationDataType = typeof decorationData;

export const literatureData: Array<quesitonArr> = [
  {
    name: "文献信息组件",
    key: "inputArray",
    questionItem: [
      {
        type: IQuestionComonentType.Question,
        name: "简答题",
        title: "请填写本项内容",
        componentName: QuestionType.fillIn,
        icon: "",
        data: {
          title: "",
          required: 1,
          content: "",
          jsonConfig: {
            subTitle: "",
            default: "",
            showIndex: true,
            inputForm: "NONE",
            inputNumberMin: undefined,
            inputNumberMax: undefined,
            inputNumberPrecision: 0,
            inputMin: undefined,
            inputMax: undefined,
          },
        } as IFillInData,
      },
      {
        type: IQuestionComonentType.Question,
        name: "日期时间",
        title: "请选择日期时间",
        componentName: QuestionType.dateTime,
        icon: "",
        data: {
          required: 1,
          uploadLimitCount: 1,
          title: "",
          jsonConfig: {
            subTitle: "",
            showIndex: true,
            dateType: "date",
            minDateType: "",
            maxDateType: "",
            minRequirementDate: "",
            maxRequirementDate: "",
          },
        } as IDateTimeData,
      },
      {
        type: IQuestionComonentType.Decoration,
        name: "描述说明",
        title: "请填写描述说明",
        componentName: DecorationType.text,
        icon: "",
        data: {
          text: "",
        } as ITextTData,
      },
    ],
  },
];

export type LiteratureDataType = typeof literatureData;

export interface showLogic {
  ifItem: number | string;
  itemOptions: Array<number | string>;

  nextItem: number | string;

  operate: string;

  thenEffect: string;
}
